import { BaseApiService } from '../../../api/base';
import type {
  IdentityUser,
  UpdatePersonalData,
  UpdateIdentityUserResult,
} from '../types/user';

class UserApiService extends BaseApiService {
  async getUser(): Promise<IdentityUser> {
    const response = await this.client.get('/identity/user');
    return response.data;
  }

  /**
   * Ensures the Firebase-authenticated user has a Volt account, creating one
   * from identity data if it does not exist yet. No request/response body —
   * just provisions on the backend. Authorized via the Firebase token attached
   * by the axios interceptor.
   */
  async ensureUser(): Promise<void> {
    await this.client.post('/auth/user');
  }

  async updatePersonalData(
    personalData: UpdatePersonalData
  ): Promise<UpdateIdentityUserResult> {
    const response = await this.client.patch('/user/personal-data', {
      ...personalData,
    });
    return response.data;
  }
}

export const userApiService = new UserApiService();
